import {Box, Skeleton} from '@mui/material';

import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

const cardSx = {
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: '12px',
  px: 3.5,
  py: 3.25,
  mb: 2.5,
  position: 'relative',
  overflow: 'hidden',
} as const;

export const DepartmentHealthNarrativeHeaderSkeleton = () => {
  return (
    <EmpionPaper sx={cardSx}>
      <Skeleton variant='text' width={220} height={14} sx={{mb: 1.125}} />
      <Skeleton variant='text' width='80%' height={32} sx={{mb: 1.25}} />
      <Skeleton variant='text' width='95%' height={18} />
      <Skeleton variant='text' width='90%' height={18} sx={{mb: 2}} />
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.875}}>
        {Array.from({length: 4}).map((_, index) => (
          <Skeleton key={index} variant='rounded' width={120} height={28} sx={{borderRadius: '99px'}} />
        ))}
      </Box>
    </EmpionPaper>
  );
};
